import { StepId } from '@/consts/assistant-steps';
import { StepDefinition } from '@/interfaces/step-definition';
import component from './Done.vue';

const config: StepDefinition = {
  component,
  id: StepId.DONE,
  isFinal: true,
};

export default config;
